import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class MaterialsApi extends ApiModule {
	constructor() {
		super(ModulesMap.MATERIALS, {
			entity: 'materials',
		})
	}

	getCurrentPricesOfMaterials(options = {}) {
		const config = {
			url: this.generateUrl(false, {
				suffix: 'current_prices',
			}),
		}

		return this.apiRequestWrap(this.moduleName, config, options)
	}
}
